import React from 'react'
import classnames from 'classnames'
import { usePagination, DOTS } from './usePagination'

const Pagination = props => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = props

    // 🔥 Cek apakah layar saat ini ukuran mobile / HP
    const isMobile = window.innerWidth < 768

    // 🔥 Panggil hooks bawaan lo, tapi kalau mobile paksa siblingCount jadi 0 biar terpangkas rapi
    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount: isMobile ? 0 : siblingCount,
        pageSize
    })

    // If there are less than 2 items in pagination range we shall not render the component
    if (currentPage === 0 || !paginationRange || paginationRange.length < 2) {
        return null
    }

    const onNext = () => {
        if (currentPage < lastPage) onPageChange(currentPage + 1)
    }

    const onPrevious = () => {
        if (currentPage > 1) onPageChange(currentPage - 1)
    }

    let lastPage = paginationRange[paginationRange.length - 1]

    return (
        <ul className={classnames('pagination-container', { [className]: className })} style={{ display: 'inline-flex', listStyleType: 'none', paddingLeft: 0 }}>
            {/* Left navigation arrow */}
            <li className={classnames('pagination-item arrow-left', { disabled: currentPage === 1 })} onClick={onPrevious}>
                <div className="arrow left" />
            </li>

            {/* Loop Angka / DOTS */}
            {paginationRange.map((pageNumber, index) => {
                // If the pageItem is a DOT, render the DOTS unicode character
                if (pageNumber === DOTS) {
                    // Pakai kombinasi index biar key-nya gak bentrok kalau DOTS-nya ada dua (kiri & kanan)
                    return <li key={`dots-${index}`} className="pagination-item dots">...</li>
                }

                // Render our Page Pills
                return (
                    <li 
                        key={pageNumber} 
                        className={classnames('pagination-item', { selected: pageNumber === currentPage })} 
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </li>
                )
            })}

            {/* Right Navigation arrow */}
            <li className={classnames('pagination-item arrow-right', { disabled: currentPage === lastPage })} onClick={onNext}>
                <div className="arrow right"/>
            </li>
        </ul>
    )
}

export default Pagination